import { render, staticRenderFns } from "./logDetails.vue?vue&type=template&id=5386d072&scoped=true&"
import script from "./logDetails.vue?vue&type=script&lang=js&"
export * from "./logDetails.vue?vue&type=script&lang=js&"
import style0 from "./logDetails.vue?vue&type=style&index=0&id=5386d072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5386d072",
  null
  
)

export default component.exports